import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { themeGet } from '@styled-system/theme-get';

import { EditFormMenu } from './EditFormMenu';
import { NewFormMenu } from './NewFormMenu';
import { PreviewFormMenu } from './PreviewFormMenu';
import { CampaignPreviewFormMenu } from './CampaignPreviewFormMenu';

export const TileActionMenu = ({
  onClose,
  uuid = '',
  currentPage,
  publishDate,
  goToEdit,
  goToPreview,
  tileStatus,
  campaignId,
  postId,
  campaignContainer,
  autoSaved,
}) => {
  return (
    <Menu>
      {uuid && currentPage === 'edit' && (
        <EditFormMenu
          goToPreview={goToPreview}
          campaignContainer={campaignContainer}
          postId={postId}
          tileStatus={tileStatus}
          publishDate={publishDate}
          onClose={onClose}
          uuid={uuid}
          autoSaved={autoSaved}
        />
      )}

      {!uuid && currentPage === 'edit' && (
        <NewFormMenu
          campaignId={campaignId}
          onClose={onClose}
          autoSaved={autoSaved}
        />
      )}

      {currentPage === 'tile-view' && (
        <PreviewFormMenu
          goToEdit={goToEdit}
          campaignContainer={campaignContainer}
          postId={postId}
          tileStatus={tileStatus}
          publishDate={publishDate}
          onClose={onClose}
          uuid={uuid}
        />
      )}

      {currentPage === 'campaign-preview' && (
        <CampaignPreviewFormMenu
          campaignContainer={campaignContainer}
          postId={postId}
          tileStatus={tileStatus}
          publishDate={publishDate}
          onClose={onClose}
          uuid={uuid}
        />
      )}
    </Menu>
  );
};

TileActionMenu.propTypes = {
  campaignContainer: PropTypes.string,
  currentPage: PropTypes.string,
  goToEdit: PropTypes.func,
  goToPreview: PropTypes.func,
  onClose: PropTypes.func,
  postId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  publishDate: PropTypes.string,
  campaignId: PropTypes.string,
  tileStatus: PropTypes.string,
  uuid: PropTypes.string,
  autoSaved: PropTypes.object,
};

const Menu = styled.div`
  background: ${themeGet('colors.background')};
  margin: 0 10px;
  padding: 10px 0;
  position: sticky;
  align-items: center;
  top: 0;
  z-index: 3;
  width: ${props => props.width};
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  display: grid;
  grid-template-areas: 'close auto-save title . switch-mode';
  grid-template-columns: 164px 1fr 500px 1fr 164px;
`;
